export const MIN_ENTRY_PANE_PERCENT = 32;
export const MAX_ENTRY_PANE_PERCENT = 72;
export const DEFAULT_ENTRY_PANE_PERCENT = 48;

export function clampEntryPanePercent(value) {
  if (value === null || value === undefined || value === "") return DEFAULT_ENTRY_PANE_PERCENT;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return DEFAULT_ENTRY_PANE_PERCENT;
  return Math.min(MAX_ENTRY_PANE_PERCENT, Math.max(MIN_ENTRY_PANE_PERCENT, numeric));
}

export function submittedPdfPreviewUrl(url) {
  const base = String(url || "").split("#")[0];
  return base ? `${base}#toolbar=1&navpanes=0&pagemode=none&scrollbar=1&view=FitH` : "";
}
